import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catTiposExcel } from "../../Categorias y Estados/catTiposExcel";

const columns = () =>
(
    {
        c_proceso_vmi_id: new EntityColumn<string>({ name: 'c_proceso_vmi_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Proceso Vmi Id' }),
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.FK, prompt: 'Cliente Id' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK, prompt: 'Fileprocess Id' }),
        vc_errores: new EntityColumn<string>({ name: 'vc_errores', type: 'varchar', flags: c.Edit, prompt: 'Errores' }),
        vc_filepath: new EntityColumn<string>({ name: 'vc_filepath', type: 'varchar', length: 2048, flags: EntityColumnFlags.None, prompt: 'Filepath' }),
        c_tipoexcel_id: new EntityColumn<string>({ name: 'c_tipoexcel_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Formato de excel' }),
        c_cliente_backoffice_id: new EntityColumn<string>({ name: 'c_cliente_backoffice_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Cliente Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        cvmi_brwStandard: { name: 'cvmi_brwStandard', keyMappings: { c_proceso_vmi_id: 0 } },
        cvmi_brwPorClienteBackoffice: { name: 'cvmi_brwPorClienteBackoffice', keyMappings: { c_proceso_vmi_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'TiposExcel': {
            name: 'TiposExcel',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposExcel(client, parentKeys)
        },
    }
)

export class ClientesVmiDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('ClientesVmi');
    }
}